import React, { Fragment } from 'react'
import { Route } from 'react-router-dom';
import { TagAmendmentApprovalListing, ViewRecord } from './Pages';

export const TagAmendmentApprovalRoutes = ({ match }) => (
    <Fragment>
        <Route exact path = {`${match.path}`} component={TagAmendmentApprovalListing} />
        <Route exact path = {`${match.path}/CompareTagAmendment`} component={ViewRecord} />
    </Fragment>
)